type NamedWorkplace = {
  name: string;
};

export function sortWorkplacesByName<T extends NamedWorkplace>(
  workplaces: readonly T[],
): T[] {
  return [...workplaces].sort((left, right) =>
    left.name.localeCompare(right.name, undefined, { sensitivity: "base" }),
  );
}
